import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Amazonservices(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="SAP Businesses">
                            <h2>Why TekRevol Recommends SAP For Businesses</h2>
                        </div>
                        <div
                            className="main_para"><p>SAP is a one-of-its-kind, turnkey ERP system that synchronizes
                            different business departments and brings them on one page to achieve organizational goals.
                            It significantly improves internal communications, opens avenues for enhanced, recorded
                            collaborations, and allows better internal reporting.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Synchronization Departments</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Data Quality and Security</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Customization Options</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>

                                        <Tab.Pane eventKey="0">
                                            <p>SAP is a one-of-its-kind, turnkey ERP system that synchronizes different
                                                business departments and brings them on one page to achieve
                                                organizational goals. It significantly improves internal communications,
                                                opens avenues for enhanced, recorded collaborations, and allows better
                                                internal reporting.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>Building onto its data collection and processing functionalities,
                                                TekRevol can help you build quality data infrastructures to lay stronger
                                                foundations for your business strategies. Internal reporting data
                                                results in better CRM outputs, improve lead gen and conversion, and help
                                                the business achieve targets in realistic timelines.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>TekRevol's SAP consulting can help you customize SAP functionalities and
                                                match them with your business requirements and future scalability goals.
                                                You can add or accelerate features, combine functionalities, and put
                                                features into action according to your organizational structure and
                                                goals with compatible coding solutions.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Synchronization Departments</Accordion.Header>
                                    <Accordion.Body>
                                        <p>SAP is a one-of-its-kind, turnkey ERP system that synchronizes different
                                            business departments and brings them on one page to achieve
                                            organizational goals. It significantly improves internal communications,
                                            opens avenues for enhanced, recorded collaborations, and allows better
                                            internal reporting.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Data Quality and Security</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Building onto its data collection and processing functionalities,
                                            TekRevol can help you build quality data infrastructures to lay stronger
                                            foundations for your business strategies. Internal reporting data
                                            results in better CRM outputs, improve lead gen and conversion, and help
                                            the business achieve targets in realistic timelines.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Customization Options</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol's SAP consulting can help you customize SAP functionalities and
                                            match them with your business requirements and future scalability goals. You
                                            can add or accelerate features, combine functionalities, and put features
                                            into action according to your organizational structure and goals with
                                            compatible coding solutions.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Amazonservices;